import type { IconNode } from '../types';

/**
 * @name pumpkin
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMgMmMtMSAxLTEgMi0xIDIiIC8+CiAgPHBhdGggZD0iTTE3IDRjLS45IDAtMS44LjQtMi41IDEuMmEzLjMyIDMuMzIgMCAwIDAtNSAwQzguOCA0LjQgNy45IDQgNyA0Yy0yLjggMC01IDQtNSA5czIuMiA5IDUgOWMuOSAwIDEuOC0uNCAyLjUtMS4yYTMuMzIgMy4zMiAwIDAgMCA1IDBjLjcuOCAxLjYgMS4yIDIuNSAxLjIgMi44IDAgNS00IDUtOXMtMi4yLTktNS05IiAvPgogIDxwYXRoIGQ9Ik0xMCAxMSA4IDlsLTIgMiIgLz4KICA8cGF0aCBkPSJtMTggMTEtMi0yLTIgMiIgLz4KICA8cGF0aCBkPSJtNiAxNSAyIDIgMi0yIDIgMiAyLTIgMiAyIDItMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/pumpkin
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pumpkin: IconNode = [
  ['path', { d: 'M13 2c-1 1-1 2-1 2', key: '1hvae7' }],
  [
    'path',
    {
      d: 'M17 4c-.9 0-1.8.4-2.5 1.2a3.32 3.32 0 0 0-5 0C8.8 4.4 7.9 4 7 4c-2.8 0-5 4-5 9s2.2 9 5 9c.9 0 1.8-.4 2.5-1.2a3.32 3.32 0 0 0 5 0c.7.8 1.6 1.2 2.5 1.2 2.8 0 5-4 5-9s-2.2-9-5-9',
      key: '1ialmf',
    },
  ],
  ['path', { d: 'M10 11 8 9l-2 2', key: '4dp8c6' }],
  ['path', { d: 'm18 11-2-2-2 2', key: 'h39xar' }],
  ['path', { d: 'm6 15 2 2 2-2 2 2 2-2 2 2 2-2', key: 'ua77yg' }],
];

export default pumpkin;
